export const GET_USERS_LIST = 'GET_USERS_LIST';
export const GET_USERS_LIST_SUCCESS = 'GET_USERS_LIST_SUCCESS';
export const GET_USERS_LIST_FAILURE = 'GET_USERS_LIST_FAILURE';

export const UPDATE_USER_STATUS = 'UPDATE_USER_STATUS';
export const UPDATE_USER_STATUS_SUCCESS = 'UPDATE_USER_STATUS_SUCCESS';
export const UPDATE_USER_STATUS_FAILURE = 'UPDATE_USER_STATUS_FAILURE';

export const ADD_ADMIN_ANALYST = 'ADD_ADMIN_ANALYST';
export const ADD_ADMIN_ANALYST_SUCCESS = 'ADD_ADMIN_ANALYST_SUCCESS';
export const ADD_ADMIN_ANALYST_FAILURE = 'ADD_ADMIN_ANALYST_FAILURE';
export const RESET_ADD_ADMIN_ANALYST_STATUS = 'RESET_ADD_ADMIN_ANALYST_STATUS';


export const DOWNLOAD_USERS_CSV = 'DOWNLOAD_USERS_CSV';
export const DOWNLOAD_USERS_CSV_SUCCESS = 'DOWNLOAD_USERS_CSV_SUCCESS';
export const DOWNLOAD_USERS_CSV_FAILURE = 'DOWNLOAD_USERS_CSV_FAILURE';

export const VALIDATE_CORPORATE = "VALIDATE_CORPORATE";
export const VALIDATE_CORPORATE_SUCCESS = "VALIDATE_CORPORATE_SUCCESS";
export const VALIDATE_CORPORATE_FAILURE = "VALIDATE_CORPORATE_FAILURE";

/* -------- USERS LIST -------- */
export const getUsersList = (role, keyword = '', page = 0, size = 10) => ({
  type: GET_USERS_LIST,
  payload: { role, keyword, page, size }
});

export const getUsersListSuccess = (role, data) => ({
  type: GET_USERS_LIST_SUCCESS,
  payload: { role, data }
});

export const getUsersListFailure = error => ({
  type: GET_USERS_LIST_FAILURE,
  payload: error
});

/* -------- UPDATE STATUS -------- */
export const updateUserStatus = (
  role,
  id,
  status,
  page = 0,
  size = 10,
  keyword = '',
  corporateId
) => ({
  type: UPDATE_USER_STATUS,
  payload: { role, id, status, page, size, keyword,corporateId }
});

export const updateUserStatusSuccess = () => ({
  type: UPDATE_USER_STATUS_SUCCESS
});

export const updateUserStatusFailure = error => ({
  type: UPDATE_USER_STATUS_FAILURE,
  payload: error
});

/* ================= ADD ADMIN / ANALYST ================= */

export const addAdminAnalyst = payload => ({
  type: ADD_ADMIN_ANALYST,
  payload
});

export const addAdminAnalystSuccess = () => ({
  type: ADD_ADMIN_ANALYST_SUCCESS
});

export const addAdminAnalystFailure = error => ({
  type: ADD_ADMIN_ANALYST_FAILURE,
  payload: error
});

export const resetAddAdminAnalystStatus = () => ({
  type: RESET_ADD_ADMIN_ANALYST_STATUS
});

/* ===================== DOWNLOAD USERS CSV ===================== */
export const downloadUsersCSV = (tab, preloading) => ({
  type: DOWNLOAD_USERS_CSV,
  payload: { tab, preloading }
});

export const downloadUsersCSVSuccess = () => ({
  type: DOWNLOAD_USERS_CSV_SUCCESS
});

export const downloadUsersCSVFailure = (error) => ({
  type: DOWNLOAD_USERS_CSV_FAILURE,
  payload: error
});


export const validateCorporate = (corporateId, callback) => ({
  type: VALIDATE_CORPORATE,
  payload: corporateId,
  callback, // optional (you are using callback pattern in saga)
});


export const validateCorporateSuccess = (data) => ({
  type: VALIDATE_CORPORATE_SUCCESS,
  payload: data,
});

export const validateCorporateFailure = (error) => ({
  type: VALIDATE_CORPORATE_FAILURE,
  payload: error,
});